import React from 'react';
import { ImageInput, required, SimpleForm, TextInput } from 'react-admin';
// import { BaseForm } from '../../Components';
import { validatePostCode } from '../../utils/validation';
import RichTextInput from 'ra-input-rich-text';
import { PreviewImageField } from '../../Components';
import { RichTextToolbar } from '../../utils/toolbarOptions';
import { columnStyles } from '../../styles';

const isValidPostCode = [required(), validatePostCode];

const LocationForm = (props) => {
  const form = columnStyles();
  return (
    <SimpleForm {...props} customRedirect="/location">
      <div className={form.container}>
        <TextInput
          className={form.column}
          source="digiticketsCatId"
          label="Digitickets CatID"
        />
        <TextInput
          className={form.column}
          source="name"
          validate={required()}
          label="Location Name"
        />
        <TextInput
          className={form.column}
          source="address"
          validate={required()}
          label="Address Line 1"
          multiline
        />
        <TextInput
          className={form.column}
          source="address2"
          label="Address Line 2"
          multiline
        />
        <TextInput
          className={form.column}
          source="city"
          validate={required()}
          multiline
        />
        <TextInput
          className={form.column}
          source="postCode"
          validate={isValidPostCode}
          label="Postcode"
          parse={(input) => input.toUpperCase()}
          multiline
        />
        <RichTextInput
          className={form.column}
          source="description"
          validate={required()}
          multiline
          toolbar={RichTextToolbar}
          label="Location Description"
        />
        <ImageInput
          className={form.column}
          source="image"
          label="Hotel Image"
          maxSize={1500000}
          placeholder= {<h5>Drop a picture to upload, or click to select it.<br></br>Max size 1.5MB</h5>}
          validate={required()}
        >
          <PreviewImageField />
        </ImageInput>
      </div>
    </SimpleForm>
  );
};

export default LocationForm;
